import React from 'react';
import { bool, number, oneOfType, string } from 'prop-types';
import { TextHighlight, Title, TitleDisplay, SponsoredSubTitle } from './showcase.styles';

const HighlightTitle = ({
  title,
  titleAs,
  titleSize,
  highlightType,
  showSponsoredSubTitle,
  betterOffer
}) => {
  const [prefix, highlight = '', suffix = ''] = title.split('"');
  const cleanSuffix = suffix.replace(', ', '');
  return /*#__PURE__*/React.createElement(TitleDisplay, {
    highlight: highlight,
    highlightType: highlightType,
    sponsored: showSponsoredSubTitle,
    betterOffer: betterOffer
  }, highlightType ? /*#__PURE__*/React.createElement(Title, {
    as: titleAs,
    fontSize: titleSize,
    "data-testid": "product-title-head"
  }, prefix, " ", /*#__PURE__*/React.createElement("span", null, highlight), " ", cleanSuffix) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Title, {
    as: titleAs,
    fontSize: titleSize,
    highlight: highlight,
    "data-testid": "product-title-head"
  }, prefix), !!highlight && /*#__PURE__*/React.createElement(TextHighlight, {
    as: titleAs,
    fontSize: titleSize,
    "data-testid": "text-highlight"
  }, highlight), !!cleanSuffix && /*#__PURE__*/React.createElement(Title, {
    as: titleAs,
    fontSize: titleSize,
    "data-testid": "text-suffix"
  }, cleanSuffix)), showSponsoredSubTitle && /*#__PURE__*/React.createElement(SponsoredSubTitle, {
    "data-testid": "sponsored-tag"
  }, "Patrocinados"));
};

process.env.NODE_ENV !== "production" ? HighlightTitle.propTypes = {
  title: string.isRequired,
  titleAs: string.isRequired,
  titleSize: oneOfType([string, number]),
  highlightType: bool,
  showSponsoredSubTitle: bool,
  betterOffer: bool
} : void 0;
HighlightTitle.defaultProps = {
  title: '',
  titleAs: 'h2',
  highlightType: false,
  showSponsoredSubTitle: false,
  betterOffer: false
};
export default HighlightTitle;